export function AnnouncementSvg({ fillColor = "#FFFFFF", size = 50 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="14 15 22 21"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 31.6348C28.7043 33.3825 27.7974 34.7009 26.1925 35.4896C25.0084 36.0715 23.76 36.1542 22.5021 35.746C21.0967 35.2896 20.0661 34.3835 19.4563 33.0454C18.8499 31.7141 18.854 30.3611 19.4324 29L21.4127 29.5453C21.0677 30.2027 20.941 30.8567 21.072 31.5649C21.3732 33.198 23.0757 34.3103 24.6962 33.9169C25.9992 33.6009 26.8809 32.5897 27.0243 31.2598C27.0355 31.1533 27.0199 31.1036 26.9485 31.0698L29 31.6348Z"
        fill={fillColor}
      />
      <path
        d="M33.8421 15.8088C33.7943 15.9803 33.8002 16.1676 33.7793 16.3731L16.1478 21.3267C16.1112 21.2527 16.0835 21.19 16.0514 21.1303C15.7743 20.6053 15.1296 20.4036 14.6089 20.6801C14.1607 20.918 14.0016 21.3207 14.0008 21.805C13.9993 23.9172 14.0001 26.0295 14.0016 28.1403C14.0016 28.271 14.0113 28.404 14.0344 28.5332C14.1099 28.9615 14.3654 29.2463 14.7665 29.3816C15.1617 29.5153 15.5322 29.4397 15.8325 29.1398C15.9648 29.0076 16.0596 28.8376 16.1777 28.6759L33.8002 33.628C33.8002 33.7399 33.798 33.8343 33.801 33.928C33.8241 34.6736 34.5473 35.179 35.248 34.9403C35.7283 34.7764 35.9995 34.3457 35.9995 33.7414C36.0003 27.9152 36.0003 22.0883 35.9988 16.2613C35.9988 16.1616 35.9868 16.0611 35.9726 15.9622C35.8934 15.4099 35.487 15.0156 34.9245 15.0004C34.4539 14.9876 33.9975 15.252 33.8421 15.8088Z"
        fill={fillColor}
      />
    </svg>
  );
}
